import { useEffect, useCallback } from 'react';
import emitter from '@/utils/eventBus';

import { PUSH_SINGLE_ROUTER } from '@/constants/event-bus';

type eventTypeName = typeof PUSH_SINGLE_ROUTER;

const useMitt = () => {
  // 监听事件
  const on = useCallback((eventName: eventTypeName, handler: any) => {
    emitter.on(eventName, handler);
    return () => emitter.off(eventName, handler);
  }, []);

  // 取消监听
  const off = useCallback((eventName: eventTypeName, handler:any) => {
    emitter.off(eventName, handler);
  }, []);

  // 触发事件
  const emit = useCallback((eventName: eventTypeName, data:any) => {
    emitter.emit(eventName, data);
  }, []);

  return { on, off, emit };
};

export default useMitt;